import React, { createContext, useReducer, ReactNode } from "react";
import type { User } from "@shared/context/AuthContext";

interface GlobalState {
  user: User | null;
  token: string | null;
  // Add other global states here
}

const initialState: GlobalState = {
  user: null,
  token: null,
  // Initialize other global states here
};

type Action =
  | { type: "SET_USER"; payload: User }
  | { type: "SET_TOKEN"; payload: string };
// Add other action types here

const GlobalStateContext = createContext<{
  state: GlobalState;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null,
});

const globalStateReducer = (
  state: GlobalState,
  action: Action,
): GlobalState => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_TOKEN":
      return { ...state, token: action.payload };
    // Handle other actions here
    default:
      return state;
  }
};

export const GlobalStateProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(globalStateReducer, initialState);

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

// Export GlobalStateContext
export { GlobalStateContext };
